import React, { Component } from 'react';
import clock_icon from '../../../../static/images/clock-icon.svg';
import { IAppState, IAction } from '../../../../models/action/core';
import { IUserCalendarProps } from '../../../../models/components/user-calendar';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import Moment from 'moment';
import { SecurityContextType } from '../../../../core/SecurityContext';
import * as Actions from '../../../../store/actions/userHome';
import { UserType } from '../../../../models/pages/login.d';
import Translator from '../../../../core/i18n';
import Loading from '../../../loading/loading';
import { Log } from 'ng2-logger';
import { ActivityType, ActivityTypeEnums } from '../../../../models/enums/ActivityType';
import * as types from '../../../../models/action/userHome';
import { withRouter } from 'react-router-dom';
import DashboardActivityItems from './dashboard-activities';
import queryString from 'querystring';
import { Common } from '../../../../core/common';
import ContentLoader from 'react-content-loader';
import assignment from '../../../../static/images/defaultImages/assigmentCard/assignment.jpg';
import i18next from 'i18next';
import 'moment/locale/tr';
import 'moment/locale/en-gb';
import 'moment/locale/ar';

const _logger = Log.create('content.tsx');

const T = Translator.create();

const _common = new Common();
let userHomeCalendarActivitiesLength: Number = new Number();
class CContent extends Component<IUserCalendarProps> {
    public state: any = { compActive: false };

    constructor(props: any) {
        super(props);
        let calendar: {};
        if (T.i18next.language === 'ar') {
            calendar = {
                sameDay: '[اليوم]',
                nextDay: '[غداً]'
            };
        } else if (T.i18next.language === 'en'){
            calendar = {
                sameDay: '[Today]',
                nextDay: '[Tomorrow]'
            };
        }
        else {
            calendar = {
                sameDay: '[Bugün]',
                nextDay: '[Yarın]'
            };
        }

        Moment.locale(T.i18next.language, { calendar });
    }

    public componentDidMount = () => {
        if (!this.props.isScrollDisable) {
            window.addEventListener('scroll', this.onScrollDetected, true);
        }
        const params = queryString.parse(window.location.search);
        const filters = _common.HandleActivityDashboardFilter();
        this.props.dispatch(
            Actions.getUserCalendarActivities(
                SecurityContextType.Class,
                params.classId ? params.classId.toString() : '',
                filters,
                this.props.startDate!,
                this.props.endDate!,
                0,
                this.props.take ? this.props.take! : 10,
                'getUserCalendarActivities',
                'get',
                filters.isFiltered ? this.callback : undefined,
                false
            )
        );
        this.setState({ compActive: true });
    };

    public componentWillUnmount() {
        window.removeEventListener('scroll', this.onScrollDetected);
        this.setState({ compActive: false });
    }

    public onScrollDetected = (event: any) => {
        if (this.props.userHomeCalendarIsLoading && !this.props.isScrollDisable && this.state.compActive) {
            if (
                event &&
                event.srcElement &&
                event.srcElement.body &&
                window.scrollY + window.innerHeight > event.srcElement.body.clientHeight - 1
            ) {
                const params = queryString.parse(window.location.search);
                const filters = _common.HandleActivityDashboardFilter();
                if (this.props.userHomeisNowThenPast) {
                    filters.isDatePassed = 1;
                    filters.dueDate = 0;
                }
                if (this.props!.skip! > 0) {
                    if (this.props.userHomeCalendarActivities &&
                        userHomeCalendarActivitiesLength != this.props.userHomeCalendarActivities.length &&
                        this.props.userHomeCalendarActivities.length > 10 * (this.props!.skip! / 10) &&
                        window.scrollY + window.innerHeight > 1000 * (this.props!.skip! / 10)
                    ) {
                        userHomeCalendarActivitiesLength = this.props.userHomeCalendarActivities.length;
                        this.props.dispatch(
                            Actions.getUserCalendarActivities(
                                SecurityContextType.Class,
                                params.classId ? params.classId.toString() : '',
                                filters,
                                this.props.startDate!,
                                this.props.endDate!,
                                this.props.skip! + (this.props.take ? this.props.take! : 10),
                                this.props.take ? this.props.take! : 10,
                                'getUserCalendarActivitiesBox',
                                'get',
                                filters.isFiltered ? this.callback : undefined
                            )
                        );
                    }
                } else {
                    if (this.props.userHomeCalendarActivities!.length != 0) {
                        this.props.dispatch(
                            Actions.getUserCalendarActivities(
                                SecurityContextType.Class,
                                params.classId ? params.classId.toString() : '',
                                filters,
                                this.props.startDate!,
                                this.props.endDate!,
                                this.props.skip! + (this.props.take ? this.props.take! : 10),
                                this.props.take ? this.props.take! : 10,
                                'getUserCalendarActivitiesBox',
                                'get',
                                filters.isFiltered ? this.callback : undefined
                            )
                        );
                    }
                }
            }
        }
    };

    callback = (pageData: any) => {
        if (pageData.length < 10 && !this.props.userHomeisNowThenPast) {
            const params = queryString.parse(window.location.search);
            const filters = _common.HandleActivityDashboardFilter();
            filters.isDatePassed = 1;
            filters.dueDate = 0;
            this.props.dispatch(
                Actions.getUserCalendarActivities(
                    SecurityContextType.Class,
                    params.classId ? params.classId.toString() : '',
                    filters,
                    this.props.startDate!,
                    this.props.endDate!,
                    0,
                    this.props.take ? this.props.take! : 10,
                    'getUserCalendarActivitiesBox',
                    'get',
                    undefined,
                    true
                )
            );
        }
    };

    public render() {
        const mycalendarComponentSpacing = 95;
        return (
            <div className="course-timeline pt-0">
                <Loading spinnerId={'getUserCalendarActivitiesBox'} type={'box'} position={'absolute'} />
                {this.props.userHomeCalendarDateArray &&
                    this.props.userHomeCalendarActivities &&
                    this.props.userHomeCalendarActivities[0] &&
                    this.props.userHomeCalendarDateArray.length > 0 ? (
                    this.props.userHomeCalendarDateArray &&
                    this.props.userHomeCalendarActivities &&
                    this.props.userHomeCalendarActivities[0] &&
                    this.props.userHomeCalendarDateArray.map((data, index) => {
                        return new Date(data).getTime() > new Date().getTime() ? (
                            <div id="activity-card" key={'calendar-' + index}>
                                <div>
                                    <h4 style={{ marginBottom: 5 }} className="course-timeline-title">
                                        {Moment(data)
                                            .calendar(undefined, { nextWeek: 'dddd, Do MMM YYYY', sameElse: 'dddd, Do MMM YYYY' })
                                            .toString()}
                                    </h4>
                                </div>
                                <DashboardActivityItems
                                    history={this.props.history}
                                    userType={this.props.userType!}
                                    isPast={false}
                                    activityList={this.props.userHomeCalendarActivities!.filter(
                                        f =>
                                            f.activityType !== ActivityType.Other &&
                                            new Date(f.dueDate!).getTime() > new Date().getTime() &&
                                            new Date(f.dueDate!).getTime() >=
                                            new Date(
                                                new Date(data).getFullYear(),
                                                new Date(data).getMonth(),
                                                new Date(data).getDate(),
                                                0,
                                                0,
                                                0
                                            ).getTime() &&
                                            new Date(f.dueDate!).getTime() <=
                                            new Date(
                                                new Date(data).getFullYear(),
                                                new Date(data).getMonth(),
                                                new Date(data).getDate(),
                                                23,
                                                59,
                                                59
                                            ).getTime()
                                    )}
                                />
                            </div>
                        ) : index === this.props.userHomeCalendarDateArray!.length - 1 ? (
                            <div>
                                <div key={'calneder-' + index}>
                                    <h4 style={{ marginBottom: 0 }} className="course-timeline-title active" tabIndex={0}>
                                        {T.t('r_user_home_calendar_history')}
                                    </h4>
                                </div>
                                <DashboardActivityItems
                                    history={this.props.history}
                                    userType={this.props.userType!}
                                    isPast={true}
                                    activityList={this.props.userHomeCalendarActivities!.filter(
                                        f => f.activityType !== ActivityType.Other && new Date(f.dueDate!).getTime() <= new Date().getTime()
                                    )}
                                />
                            </div>
                        ) : (
                            ''
                        );
                    })
                ) : (
                    <a style={{ alignItems: 'center' }}>{T.t('r_home_box_interactions_not_found')}</a>
                )}
                {this.props.userHomeCalendarDateArray &&
                    this.props.userHomeCalendarActivities &&
                    this.props.userHomeCalendarActivities[0] &&
                    this.props.userHomeCalendarDateArray.length > 0 ? (
                    <Loading spinnerId={'getUserCalendarActivities'}>
                        <div style={{ backgroundColor: '#fbfaf6' }}>
                            <ContentLoader
                                speed={2}
                                backgroundColor="#f3f3f3"
                                foregroundColor="#ecebeb"
                                viewBox="0 0 350 570"
                                style={{ width: '100%' }}
                            >
                                <rect x="0" y="0" rx="3" ry="3" width="355" height="55" />
                                <rect x="0" y="65" rx="3" ry="3" width="355" height="55" />
                                <rect x="0" y="130" rx="3" ry="3" width="355" height="55" />
                                <rect x="0" y="195" rx="3" ry="3" width="355" height="55" />
                                <rect x="0" y="260" rx="3" ry="3" width="355" height="55" />
                            </ContentLoader>
                        </div>
                    </Loading>
                ) : (
                    ''
                )}
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IUserCalendarProps): IUserCalendarProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: IUserCalendarProps = Object.assign({}, ownProps, {
        userHomeCalendarActivities: state.userHomePage.userHomeCalendarActivities,
        userHomeCalendarIsLoading: state.userHomePage.userHomeCalendarIsLoading,
        userType: state.login.identitiy.userType,
        skip: state.userHomePage.userHomeCalendarSkip,
        userHomeCalendarDateArray: state.userHomePage.userHomeCalendarDateArray,
        userHomeisNowThenPast: state.userHomePage.userHomeisNowThenPast
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.userHomePage.userHomeCalendarActivities === prev.userHomePage.userHomeCalendarActivities;
    return ret;
};
const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const Content = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(CContent);

export default withRouter<any, any>(Content);
